import {
    DEFAULT_PREFERENCES,
    LOCAL_STORAGE_PREFIX,
} from "../../constants/userPreferences";
import log from "../../utils/logger/library";
import { isServer } from "../environmentDetection/library";
/**
 * Cache preference value in local storage
 * NOP if caching isn't enabled for given preference
 * @param {string} preference
 * @param {string|number} value
 */
export function cache(preference, value) {
    if (isServer()) {
        return;
    }

    window.localStorage &&
        window.localStorage.setItem(LOCAL_STORAGE_PREFIX + preference, value);
}

/**
 * Retrieve cached preference from local storage
 * @param {string} preference
 * @return {string|number} cached preference, undefined if not cached or caching not supported/enabled
 */
export function getCached(preference) {
    if (isServer()) {
        return;
    }
    let value;
    try {
        value = window.localStorage.getItem(LOCAL_STORAGE_PREFIX + preference);
    } catch (error) {
        log.error(`(getCached) cookies disabled`, error);
        return;
    }

    return value === null ? undefined : value;
}

/**
 * Delete all cached preferences
 */
export function resetCache() {
    Object.keys(DEFAULT_PREFERENCES).forEach((preference) => {
        if (isServer()) {
            return;
        }

        window.localStorage &&
            window.localStorage.removeItem(LOCAL_STORAGE_PREFIX + preference);
    });
}
